import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import {
  getAllModGroupsWithDescriptions,
  getValidCartItems,
} from '../utils/cart';
import { selectIsExpressUpsellMode } from './menu';
import {
  selectHasCheckTotal,
  selectPromptAskCounts,
  selectPromptOverrides,
  selectWithheldConstraints,
} from '../redux/features/experiments/experiments.selector';

const selectCart = (state: RootState) => state.cart;
const selectCartModality = createSelector(selectCart, (cart) => cart.modality);
const selectCartItems = createSelector(selectCart, (cart) => cart.cartItems);
const selectCartItemsQuantity = createSelector(
  selectCart,
  (cart) => cart.cartItemsQuantity
);

const selectValidCartItems = createSelector(selectCartItems, (cartItems) =>
  getValidCartItems(cartItems)
);
const selectHypothesisCartItems = createSelector(
  selectCart,
  (cart) => cart.hypothesisCartItems
);

const selectCartLoyalties = createSelector(
  selectCart,
  (cart) => cart.loyalties
);

const selectModGroupsWithDescriptions = createSelector(
  selectCartItems,
  selectIsExpressUpsellMode,
  selectWithheldConstraints,
  selectPromptOverrides,
  selectPromptAskCounts,
  selectHasCheckTotal,
  (
    cartItems,
    isExpressUpsellMode,
    withheldConstraints,
    prompts,
    promptAskCounts,
    hasCheckTotal
  ) =>
    getAllModGroupsWithDescriptions(cartItems, isExpressUpsellMode, {
      withheldConstraints,
      prompts,
      promptAskCounts,
      hasCheckTotal,
    })
);

export {
  selectCart,
  selectCartItems,
  selectCartItemsQuantity,
  selectCartModality,
  selectValidCartItems,
  selectHypothesisCartItems,
  selectCartLoyalties,
  selectModGroupsWithDescriptions,
};
